import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=2d8c4d12&scoped=true&"
import script from "./CookieBanner.vue?vue&type=script&lang=ts&"
export * from "./CookieBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=2d8c4d12&lang=scss&scoped=scoped&"
import style1 from "./CookieBanner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c4d12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VImg,VOverlay})
